import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { ICompanyAutoComplete } from '~types/company';

import QueryKeys from '../queryKeys';

const url = (search?: string) => `/api/search/autocomplete?q=${search}&index=0&size=5`;

function useGetCompanyAutoComplete(search?: string) {
  return useQuery<ICompanyAutoComplete>(
    [QueryKeys.autoComplete, search],
    () => fetcher(url(search)),
    {
      enabled: !search || search.length !== 0,
    },
  );
}

export default useGetCompanyAutoComplete;
